import React from 'react';
import PropTypes from 'prop-types';

const toNum = (v) => Number(v) || 0;

// Horizontal ranked bars: items = [{ label, value, sub? }].
export const BarList = ({ items, color, valueFmt, emptyText }) => {
  const list = items || [];
  if (list.length === 0) return <p className="tw-text-slate-500 tw-text-xs tw-italic tw-mb-0">{emptyText}</p>;
  const max = Math.max(1, ...list.map((i) => toNum(i.value)));
  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      {list.map((i) => (
        <div key={i.label} className="tw-flex tw-items-center tw-gap-2">
          <span className="tw-text-xs tw-text-slate-700 tw-truncate" style={{ width: 150 }} title={i.label}>{i.label}</span>
          <div className="tw-flex-1 tw-bg-slate-100 tw-rounded-xl" style={{ height: 10, overflow: 'hidden' }}>
            <div style={{ width: `${(toNum(i.value) / max) * 100}%`, height: '100%', background: color }} />
          </div>
          <span className="tw-text-xs tw-font-bold tw-text-slate-700" style={{ width: 70, textAlign: 'right' }}>{valueFmt(i.value)}</span>
        </div>
      ))}
    </div>
  );
};

BarList.propTypes = {
  items: PropTypes.array,
  color: PropTypes.string,
  valueFmt: PropTypes.func,
  emptyText: PropTypes.string
};
BarList.defaultProps = { items: [], color: '#3b82f6', valueFmt: (v) => Number(v || 0).toLocaleString('en-US'), emptyText: 'No data.' };

// Vertical monthly bars: items = [{ label, ...}], plotting `valueKey`.
export const MonthlyBars = ({ items, valueKey, color, height, onBarClick }) => {
  const list = items || [];
  if (list.length === 0) return <p className="tw-text-slate-500 tw-text-xs tw-italic tw-mb-0">No data.</p>;
  const max = Math.max(1, ...list.map((m) => toNum(m[valueKey])));
  return (
    <div className="tw-flex tw-items-end tw-justify-between tw-gap-2" style={{ height }}>
      {list.map((m) => (
        <div
          key={m.label}
          className="tw-flex tw-flex-col tw-items-center tw-flex-1"
          style={onBarClick ? { cursor: 'pointer' } : undefined}
          title={`${m.label}: ${toNum(m[valueKey]).toLocaleString('en-US')}`}
          onClick={onBarClick ? () => onBarClick(m) : undefined}
        >
          <span className="tw-text-[11px] tw-font-bold tw-text-slate-700 tw-mb-1">{toNum(m[valueKey]).toLocaleString('en-US')}</span>
          <div className="tw-rounded-t-md" style={{ width: '70%', height: `${(toNum(m[valueKey]) / max) * (height - 34)}px`, minHeight: 2, background: color }} />
          <span className="tw-text-[11px] tw-text-slate-500 tw-mt-1 tw-truncate" style={{ maxWidth: 52 }}>{m.label}</span>
        </div>
      ))}
    </div>
  );
};

MonthlyBars.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  onBarClick: PropTypes.func
};
MonthlyBars.defaultProps = { items: [], valueKey: 'value', color: '#3b82f6', height: 150, onBarClick: null };
